// Colore/icona associati allo stato amministrativo di un fitofarmaco
// ministeriale (es. "Autorizzato", "Revocato"). Condiviso tra la card di
// dettaglio nel dialog "Nuovo Carico" e la riga della lista fitofarmaci in
// magazzino, per evitare di duplicare la stessa logica in due posti.
export function statoChipColor(stato) {
  let s = stato || "";
  if (/revoc/i.test(s)) {
    return "red darken-1";
  }
  if (/autorizz/i.test(s)) {
    return "green darken-1";
  }
  return "grey";
}

export function statoChipIcon(stato) {
  let s = stato || "";
  if (/revoc/i.test(s)) {
    return "mdi-close-octagon-outline";
  }
  if (/autorizz/i.test(s)) {
    return "mdi-check-circle-outline";
  }
  return "mdi-help-circle-outline";
}
